import { Adapter as o, getAdapter as e } from "../../../../adapter.js";
import { ShopSessionAddressAdapter as p } from "./address/address.adapter.js";
import { ShopSessionCashbackAdapter as i } from "./cashback/shopSessionCashback.adapter.js";
import { ShopSessionSettingsModel as a } from "./settings.model.js";
import { ShopSessionShopAdapter as t } from "./shop/shop.adapter.js";
import { ShopSessionUserAdapter as r } from "./user/user.adapter.js";
import { ShopSessionAccessAdapter as c } from "./access/shopSessionAccess.adapter.js";
import { AnalyticsAdapter as d } from "../../../analytics/analytics.adapter.js";
class v extends o {
  adapt(s) {
    return new a({
      language: s.language,
      address: s.address ? e(p).adapt(s.address) : void 0,
      access: s.access ? e(c).adapt(s.access) : void 0,
      user: s.user ? e(r).adapt(s.user) : void 0,
      cashback: s.cashback ? e(i).adapt(s.cashback) : void 0,
      analytics: s.analytics ? e(d).adapt(s.analytics) : void 0,
      shop: e(t).adapt(s.shop)
    });
  }
  serialize(s) {
    return {
      user: s.user ? e(r).serialize(s.user) : void 0
    };
  }
}
export {
  v as ShopSessionSettingsAdapter
};
//# sourceMappingURL=settings.adapter.js.map
